<style>
.num1 {
  text-align: center;
  width: 50%;
  color: #fff;
  margin-top: 0.3rem;
  font-size: 0.7rem;
  border-right: solid #acc0d8 2px;
  float: left;
}
.num2 {
  text-align: center;
  width: 50%;
  color: #fff;
  margin-top: 0.3rem;
  font-size: 0.7rem;
  float: right;
}
.sacans {
  font-size: 0.3rem;
}
.sacanp {
  font-weight: bold;
}
.hexiaop {
  font-size: 0.1rem;
  text-align: center;
}
</style>
<template>
  <div class="my-promotion">
    <div class="header">
      <div class="name acea-row row-center-wrapper">
        <router-link class="record" :to="'/user/cashrecord'">
          提现记录
          <span class="iconfont icon-xiangyou"></span>
        </router-link>
      </div>
      <div class="num1">
        <scan class="sacans">可提现金额(元)</scan>
        <p class="sacanp">{{ keTi.money || 0 }}</p>
      </div>
      <div class="num2">
        <scan class="sacans">待核销金额(元)</scan>
        <p class="sacanp">{{ heXiao.daihe || 0 }}</p>
      </div>
    </div>
    <div class="bnt bg-color-red" @click="toCash">立即提现</div>
    <div class="list acea-row row-between-wrapper">
      <router-link class="item acea-row row-center-wrapper row-column" :to="'/user/ketixian_order'">
        <span class="iconfont icon-dingdan"></span>
        <div style="color: initial;">已核销订单</div>
        <div class="hexiaop">(可提现)</div>
      </router-link>

      <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/daihexiao_order'"
      >
        <span class="iconfont icon-tongji"></span>
        <div style="color: initial;">待核销订单</div>
        <div class="hexiaop">(含部分核销)</div>
      </router-link>

      <router-link class="item acea-row row-center-wrapper row-column" :to="'/user/promoter_list'">
        <span class="iconfont icon-tongji"></span>
        <div>推广人统计</div>
      </router-link>
      <router-link class="item acea-row row-center-wrapper row-column" :to="'/user/promoter_order'">
        <span class="iconfont icon-dingdan"></span>
        <div>推广人订单</div>
      </router-link>

      <router-link class="item acea-row row-center-wrapper row-column" :to="'/user/poster'">
        <span class="iconfont icon-erweima"></span>
        <div>推广名片</div>
      </router-link>
      <!-- <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/commission'"
      >
        <span class="iconfont icon-qiandai"></span>
        <div>红包明细</div>
      </router-link>-->
      <router-link class="item acea-row row-center-wrapper row-column" :to="'/user/promoter_rank'">
        <span class="iconfont icon-paihang1"></span>
        <div>推广人排行</div>
      </router-link>
      <!--<router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/commission/rank'"
      >
        <span class="iconfont icon-paihang"></span>
        <div>红包排行</div>
      </router-link>-->
    </div>
  </div>
</template>
<script>
import { getUser } from "../../../api/user";
import { getUserKeti, getUserHexiao } from "../../../api/yongjin";

export default {
  name: "UserPromotion",
  components: {},
  props: {},
  data: function() {
    return {
      userInfo: {},
      keTi: {},
      heXiao: {}
    };
  },
  watch: {
    // $route(n) {
    //   if (n.name == "UserPromotion") this.getInfo();
    // }
  },
  mounted: function() {
    this.getInfo();
    this.getMoney();
    this.getHexiao();
  },
  methods: {
    getInfo: function() {
      let that = this;
      getUser().then(
        res => {
          that.userInfo = res.data;
          console.log(that.userInfo);
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
    getMoney: function() {
      let that = this;
      getUserKeti().then(
        res => {
          that.keTi = res.data;
          console.log(that.keTi);
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
    getHexiao: function() {
      let that = this;
      getUserHexiao().then(
        res => {
          that.heXiao = res.data;
          console.log(that.heXiao);
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
    toCash: function() {
      this.$router.push({ path: "/user/user_cash" });
    }
  }
};
</script>
